<template>
    <div class="result-container">
        <div class="result-module">
            <div class="subtitle result-state-success" v-if="userAnswerState">
                <span>回答正确</span>
                <van-icon name="checked" />
            </div>
            <div class="subtitle result-state-error" v-else>
                <span>回答错误</span>
                <van-icon name="clear" />
            </div>

            <div class="answer success-answer">
                <div class="label">正确答案:</div>
                <TextTemplate class="content content-success" :text="successAnswer" />
            </div>
            <div class="answer user-answer">
                <div class="label">我的答案:</div>
                <TextTemplate class="content" :text="userAnswer || '未作答'" />
            </div>
        </div>
        <div class="result-module" v-if="analysisText">
            <div class="subtitle">解析</div>
            <TextTemplate class="analysis" :text="analysisText" />
        </div>
    </div>
</template>
<script>
import TextTemplate from '../TextTemplate.vue'

export default {
    components: { TextTemplate },
    props: ['question'],
    computed: {
        userAnswerMap() {
            return this.$store.state.paperResult.userAnswerMap
        },
        questionAnalysisMap() {
            return this.$store.state.paperResult.questionAnalysisMap
        },
    },
    data() {
        return {
            userAnswer: '',
            userAnswerState: false,
            successAnswer: '',
            analysisText: '',
        }
    },
    created() {
        const { state, answer } = this.userAnswerMap[`q-${this.question.id}`]
        const analysis = this.questionAnalysisMap[`q-${this.question.id}`]
        this.userAnswer = answer || ''
        this.userAnswer = this.userAnswer.split('@@').join('、')
        this.userAnswerState = state || false
        this.successAnswer = analysis.answer.split('@@').join('、')
        this.analysisText = analysis.analysisContent
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/paper.scss';

.result-container {
    margin-top: 16px;
}
.result-module {
    padding: 20px 0;
    position: relative;
    &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
        width: 100%;
        height: 10px;
        background: #eeeeee;
    }
    .subtitle {
        height: 42px;
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
    }

    .result-state-success {
        color: $success-color;
    }
    .result-state-error {
        color: $error-color;
    }
    .result-state-success,
    .result-state-error {
        font-size: 16px;
        .van-icon {
            margin-left: 8px;
        }
    }
    .analysis {
        font-size: 15px;
        line-height: 1.4em;
        color: #666;
    }
}
.answer {
    margin: 4px 0 12px;
    border-radius: 4px;
    background: #efefef;
    // box-shadow: 0 0 20px rgba($color: #000000, $alpha: 0.1);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    min-height: 42px;
    .label {
        font-size: 13px;
        color: #888;
        padding-left: 12px;
        min-height: 42px;
        display: flex;
        align-items: center;
    }
    .content {
        padding: 0 12px;
        font-size: 15px;
        line-height: 1.4em;
        color: #333;
    }
    .content-success {
        color: $success-color;
    }
}
</style>
